<template>
  <transition name="scaleUp">
    <div class="subject" :style="{'background-color': subject.color}" v-on-clickaway="addSubject">
      <input type="number" ref="count"
             class="subject__input-number"
             v-model="hours"
             @keyup.enter="addSubject"
             @focus="selectAll">
    </div>
  </transition>
</template>

<script>
  import {mixin as clickaway} from 'vue-clickaway'

  export default {
    mixins: [clickaway],
    props: {
      subject: {
        default: null
      },
      calendar: {
        default: null
      }
    },
    data () {
      return {
        hours: 0
      }
    },
    methods: {
      close () {
        this.$emit('close')
        this.hours = 0
      },
      selectAll (event) {
        setTimeout(function () {
          event.target.select()
        }, 0)
      },
      addSubject () {
        if (this.hours < 0 || isNaN(this.hours)) {
          this.isCreateSubject = false
          this.hours = 0
          return
        }
        let newSubject = {
          subject: this.subject,
          calendar: this.calendar,
          hours: this.hours
        }
        this.$emit('createSubject', newSubject)
      }
    },
    mounted () {
      setTimeout(_ => {
        this.$refs.count.focus()
      }, 0)
    }
  }
</script>

<style scoped>

  .subject-create .subject {
    position: absolute;
    z-index: 12;
    top: 0;
    left: 0;
    width: 100%;
    padding: 4px 6px;
    height: 30px;
    color: #ffffff !important;
    border-radius: 4px;
    word-break: break-all;
    background: #2c81ba;
    overflow: hidden;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
    opacity: 0.9;
    text-align: left;
  }

  .subject__create {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 6px;
    color: #ffffff !important;
    border-radius: 4px;
    word-break: break-all;
    background: #eeeeee;
    overflow: hidden;
    opacity: 0.9;
    text-align: left;
    cursor: pointer;
    height: 30px;
    transition: box-shadow 0.25s, border-color 0.25s;
    border: 1px solid transparent;
  }

  .subject__create:hover {
    box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
    border-color: #468AD7;
  }

  .subject__create__plus {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--dark-blue);
    height: 24px;
    width: 24px;
    border-radius: 50%;
    background-color: #c0c0c0;
  }

  .subject__input-number, input[type="number"]:focus.subject__input-number {
    background: transparent;
    border: none;
    padding: 4px 6px;
    border-bottom: 1px solid #ffffff;
    border-radius: 0;
    color: #ffffff;
    font-size: 12px;
  }

  .scaleUp-enter-active {
    transition: transform 0.25s;
  }

  .scaleUp-enter {
    transform: scale(0);
  }
</style>



// WEBPACK FOOTER //
// BulkCreateSubjectsSubject.vue?331c28d8